module.exports = __webpack_public_path__ + "img/tgo-intro-h5.984ea203.png";